import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from '@/store/store.ts';

export const getAllGrowls = createSelector(
  (state: AppState) => state.growls,
  (growls) => {
    return Object.entries(growls)
      .map(([growlId, growl]) => {
        return { id: growlId, ...growl };
      })
      .sort((leftGrowl, rightGrowl) => rightGrowl.createdAt - leftGrowl.createdAt);
  },
);
